import { validatePythonVariable } from '@polyai/common/lib/stringHelper';
import type { ApiIntegration } from '@polyai/stream/store/reducers/api-integrations/types';
import type { Flow } from '@polyai/stream/store/reducers/flows';
import type { Function } from '@polyai/stream/store/reducers/functions';

export const validateStreamFunctionName =
  (existingValues: Function[] = [], current?: Omit<Function, 'references'>) =>
  (name: string) => {
    const error = validatePythonVariable(name);
    if (error !== true) {
      return error;
    }

    const isNameInUse = existingValues.some(
      v => v.name === name && v.id !== current?.id,
    );

    return isNameInUse ? `${name} is already in use` : true;
  };

export const validateApiName =
  (existingValues: ApiIntegration[] = [], currentId?: string) =>
  (name: string) => {
    const error = validatePythonVariable(name);
    if (error !== true) {
      return error;
    }

    const isNameInUse = existingValues.some(
      v => v.name === name && v.id !== currentId,
    );
    return isNameInUse ? `${name} is already in use` : true;
  };

export const validateFlowName =
  (existingValues: Flow[] = []) =>
  (name: string) => {
    const isNameInUse = existingValues.some(v => v.name === name);

    return isNameInUse ? `${name} is already in use` : true;
  };
